import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import type { FC } from 'react';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import type { MultipleReceiptItem, SingleReceiptItem } from '@swf/core/models/sports/betSlip/types';

import { TXTACL_StakeX, TXTWCL_N0_Bonus_Cash, TXTWCL_N0_Free_Bet } from './StakeRow.messages.json';
import styles from './StakeRow.scss';

interface Props {
  receiptItem: SingleReceiptItem | MultipleReceiptItem;
}

export const StakeRow: FC<Props> = ({ receiptItem }) => {
  const { totalStake, appliedBonusCash, isFreeBet } = receiptItem;
  return (
    <p className={styles.container}>
      <span>
        <Translation {...TXTACL_StakeX} />
      </span>{' '}
      <span
        className={classNames(styles.value, {
          [styles.bonusCash]: appliedBonusCash
        })}
      >
        {appliedBonusCash ? (
          <Translation
            {...(isFreeBet ? TXTWCL_N0_Free_Bet : TXTWCL_N0_Bonus_Cash)}
            values={{ 0: <CurrencyAmount value={appliedBonusCash || 0} /> }}
          />
        ) : totalStake ? (
          <CurrencyAmount value={totalStake || 0} />
        ) : (
          '-'
        )}
      </span>
    </p>
  );
};
